import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useHistory, useLocation } from "react-router";
import swal from "sweetalert";
import {
    GetAllCompanyData,
    deleteOthersDetailsIr,
    getInvestmentSummary,
    getLinkedCompanies,
    deleteInvestmentTransaction,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import Sidebar from "../../../myfin_v2/elements/Sidebar";
import DeletePopup from "../../../myfin_v2/elements/DeletePopup";
import SuccessPopup from "../../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../../myfin_v2/elements/ErrorPopup";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as FilterIcon } from "../../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusIconBlack } from "../../../myfin_v2/assets/icons/plusBlack.svg";
import { ReactComponent as DownloadIcon } from "../../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as DownArrow } from "../../../myfin_v2/assets/icons/down-arrow.svg";
import EmptyBox from "../../../myfin_v2/assets/icons/empty-box.png";

const IRDetails = () => {
    const history = useHistory();
    //const [IrData, setIrData] = useState([]);
    const [IrSummary, setIrSummary] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl3, setAnchorEl3] = useState(null);
    const [IrOneData, setIRData] = useState("");
    const [deletePopup, setDeletePopup] = useState({ isOpen: false, data: null });
    const [successPopup, setSuccessPopup] = useState({ isOpen: false, message: "" });
    const [errorPopup, setErrorPopup] = useState({ isOpen: false, message: "" });
    const location = useLocation();
    const b = location.pathname.split("/");
    const registerID = b[2];

    const [allCompany, setAllCompany] = useState([]);

    // ── Replaced static groups with API-driven company list ───────────────────
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [companySearch, setCompanySearch] = useState("");
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const dropdownRef = useRef(null);

    useEffect(() => {
        companyData();
        fetchLinkedCompanies();
    }, []);

    useEffect(() => {
        const investorCompanyId = (selectedCompany && selectedCompany._id !== "ALL") ? selectedCompany._id : undefined;
        fetchInvestmentSummary(investorCompanyId);
    }, [selectedCompany]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpenDropdown(false);
                setCompanySearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const isAllVisible = !companySearch || "all".includes(companySearch.toLowerCase()) || "all companies".includes(companySearch.toLowerCase());
    const filteredCompanies = companies.filter(c =>
        c.company_name.toLowerCase().includes((companySearch || "").toLowerCase())
    );
    const allDropdownOptions = [
        ...(isAllVisible ? [{ _id: "ALL", company_name: "All" }] : []),
        ...filteredCompanies
    ];

    const handleDropdownKeyDown = (e) => {
        if (!openDropdown) {
            if (e.key === "ArrowDown" || e.key === "Enter") {
                setOpenDropdown(true);
                setHighlightedIndex(0);
                e.preventDefault();
            }
            return;
        }

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev < allDropdownOptions.length - 1 ? prev + 1 : 0
            );
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prev) =>
                prev > 0 ? prev - 1 : allDropdownOptions.length - 1
            );
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (allDropdownOptions.length > 0 && allDropdownOptions[highlightedIndex]) {
                const opt = allDropdownOptions[highlightedIndex];
                if (opt._id === "ALL") {
                    setSelectedCompany(null);
                } else {
                    setSelectedCompany(opt);
                }
                setCompanySearch("");
                setOpenDropdown(false);
            }
        } else if (e.key === "Escape") {
            setOpenDropdown(false);
            setCompanySearch("");
        }
    };

    const open = Boolean(anchorEl3);
    const id = open ? "simple-popover" : undefined;

    // ── Fetch linked companies for dropdown ───────────────────────────────────
    const fetchLinkedCompanies = async () => {
        try {
            const res = await getLinkedCompanies(registerID);
            // API: { success: true, companies: [{ _id, company_name, company_code }] }
            const list = res.data?.companies || [];
            setCompanies(list);
        } catch (error) {
            console.error("Failed to fetch linked companies:", error);
        }
    };

    const companyData = async () => {
        try {
            const res = await GetAllCompanyData();
            if (res.status === 200) {
                setAllCompany(res.data.getAllCompanyData);
            }
        } catch (error) {
            console.log(error.message, "error");
        }
    };

   const fetchInvestmentSummary = async (investorCompanyId) => {
    try {
        setLoading(true);
        const res = await getInvestmentSummary(registerID, investorCompanyId);

        if (res.data.success) {
            setIrSummary(res.data.summary || []);
        }
    } catch (error) {
        console.error("Summary fetch failed:", error);
    } finally {
        setLoading(false);
    }
};

    const CompanyName = (c_id) => {
        try {
            const nameCompany = allCompany.filter((adj) => adj._id === c_id);
            return nameCompany[0]?.company_name || "";
        } catch (error) {
            return "";
        }
    };

    const handleClick = (event, data) => {
        setAnchorEl3(event.currentTarget);
        setIRData(data);
    };

    const handleClose = () => {
        setAnchorEl3(null);
    };

    const handleEditIr = (data) => {
        history.push(`/edit-investment/${registerID}`);
    };

    const handleDeleteClick = (data) => {
        setDeletePopup({ isOpen: true, data });
        handleClose();
    };

    const handleConfirmDelete = async () => {
        const data = deletePopup.data;
        setDeletePopup({ isOpen: false, data: null });
        try {
            await deleteInvestmentTransaction(
                registerID,           
                data?.latestTransaction?._id  
            );

            const investorCompanyId = (selectedCompany && selectedCompany._id !== "ALL") ? selectedCompany._id : undefined;
            fetchInvestmentSummary(investorCompanyId);
            setSuccessPopup({ isOpen: true, message: "Investment deleted successfully." });
        } catch (err) {
            console.error("Failed to delete investment:", err);
            const errMsg = err?.response?.data?.error || err?.response?.data?.message || "Failed to delete investment";
            setErrorPopup({ isOpen: true, message: errMsg });
        }
    };
    const formatIndianCurrency = (value) => {
        if (value === null || value === undefined || value === "") return "-";

        const amount = Number(value);

        const formatted = Math.abs(amount).toLocaleString("en-IN");

        return amount < 0 ? `(${formatted})` : formatted;
        };

    const filteredSummary = IrSummary;

    return (
        <div className={commoncss.pageLayout}>
            <Sidebar />
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu activeTab={"Investments"} registerID={b[2]} />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRContainer}>
                        <div className={investmentRegisterCss.topBar}>

                            {/* ── Linked Companies Dropdown ── */}
                            <div className={investmentRegisterCss.dropdownWrapper} ref={dropdownRef}>
                                <div
                                    className={investmentRegisterCss.dropdownField}
                                    onClick={() => setOpenDropdown(true)}
                                >
                                    <input
                                        type="text"
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            outline: "none",
                                            color: "#205a46",
                                            fontSize: "14px",
                                            width: "100%",
                                            padding: 0,
                                            cursor: "pointer",
                                        }}
                                        placeholder="Select Companies"
                                        value={openDropdown ? companySearch : (selectedCompany && selectedCompany._id !== "ALL" ? selectedCompany.company_name : "All")}
                                        onFocus={() => {
                                            setCompanySearch("");
                                            setHighlightedIndex(0);
                                            setOpenDropdown(true);
                                        }}
                                        onChange={(e) => {
                                            setCompanySearch(e.target.value);
                                            setHighlightedIndex(0);
                                            setOpenDropdown(true);
                                        }}
                                        onKeyDown={handleDropdownKeyDown}
                                    />
                                    <motion.span
                                        animate={{ rotate: openDropdown ? 180 : 0 }}
                                        transition={{ duration: 0.2 }}
                                        className={investmentRegisterCss.chevron}
                                        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpenDropdown(prev => !prev);
                                        }}
                                    >
                                        <DownArrow />
                                    </motion.span>
                                </div>
                                {openDropdown && (
                                    <div className={investmentRegisterCss.dropdownMenuScrollable}>
                                        {allDropdownOptions.length > 0 ? (
                                            allDropdownOptions.map((opt, i) => {
                                                const isSelected =
                                                    (opt._id === "ALL" && (!selectedCompany || selectedCompany._id === "ALL")) ||
                                                    selectedCompany?._id === opt._id;
                                                const isHighlighted = highlightedIndex === i;

                                                return (
                                                    <div
                                                        key={opt._id}
                                                        className={`${investmentRegisterCss.dropdownItem} ${isSelected || isHighlighted ? investmentRegisterCss.dropdownItemActive : ""}`}
                                                        style={isHighlighted ? { backgroundColor: "#f4faf5", color: "#205a46" } : {}}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onClick={() => {
                                                            if (opt._id === "ALL") {
                                                                setSelectedCompany(null);
                                                            } else {
                                                                setSelectedCompany(opt);
                                                            }
                                                            setCompanySearch("");
                                                            setOpenDropdown(false);
                                                        }}
                                                    >
                                                        {opt.company_name}
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className={investmentRegisterCss.dropdownItem} style={{ color: "#b3c0bd", cursor: "default" }}>
                                                No companies found
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className={investmentRegisterCss.iRHeader}>
                                {/* <FilterIcon />
                                <Button
                                    btnColor={buttoncss.greyBg}
                                    icon={<DownloadIcon height={16} />}
                                    label="Export"
                                /> */}
                                <Button
                                    btnColor={buttoncss.primary}
                                    icon={<PlusIcon />}
                                    label="Create Investment"
                                    onClick={() => history.push(`/create-investment/${registerID}`)}
                                />
                            </div>
                        </div>

                        <div className={investmentRegisterCss.iRDataContainer}>
                            <table className={investmentRegisterCss.irTable} style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th style={{ borderTopLeftRadius: "10px", textAlign: "left", paddingLeft: "20px" }}>Investor</th>
                                        <th style={{ textAlign: "left", paddingLeft: "20px" }}>Investees</th>
                                        <th style={{ textAlign: "right", paddingRight: "40px" }}>Investment value</th>
                                        <th style={{ textAlign: "right", paddingRight: "40px" }}>Number of shares</th>
                                        <th style={{ textAlign: "right", paddingRight: "40px" }}>Percentage holding</th>
                                        <th style={{ textAlign: "left", paddingLeft: "20px" }}>Nature of relationship</th>
                                        <th style={{ borderTopRightRadius: "10px" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr style={{ height: "100%" }}>
                                            <td colSpan={7} style={{ height: "78vh", textAlign: "center", verticalAlign: "middle" }}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%",
                                                }}>
                                                    <style>{`@keyframes spin {0% {transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
                                                    <div style={{
                                                        width: 60,
                                                        height: 60,
                                                        borderRadius: "50%",
                                                        border: "6px solid rgba(0, 0, 0, 0.1)",
                                                        borderTopColor: "#47b36b",
                                                        animation: "spin 0.9s linear infinite",
                                                    }} />
                                                </div>
                                            </td>
                                        </tr>
                                    ) : filteredSummary.length === 0 ? (
                                        <tr style={{ height: "100%" }}>
                                            <td colSpan={7} style={{ height: "78vh", textAlign: "center", verticalAlign: "middle" }}>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px" }}>
                                                    <img src={EmptyBox} alt="No investments" style={{ width: "250px", height: "100px" }} />
                                                    <p style={{ fontWeight: "600", fontSize: "20px", color: "#183930", margin: 0 }}>No Investments are added</p>
                                                    <p style={{ fontSize: "16px", color: "#4D6D64", margin: 0 }}>Create a new investment</p>
                                                    <button
                                                        onClick={() => history.push(`/create-investment/${registerID}`)}
                                                        style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "8px", padding: "8px 20px", border: "1px solid #7ECEA7", borderRadius: "8px", background: "#fff", cursor: "pointer", fontSize: "16px", color: "#1A4338", fontWeight: "500", lineHeight: "1" }}
                                                    >
                                                        <PlusIconBlack style={{ width: "14px", height: "14px" }} />
                                                        Create Investment
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                       filteredSummary.map((row, index) => {
                                        const latest = row.latestTransaction || {};
                                        const investorName =
                                            row.investorCompanyData?.company_name ||
                                            row.latestTransaction?.investorCompanyData?.company_name ||
                                            CompanyName(row.latestTransaction?.investorCompanyID) ||
                                            CompanyName(row.investorCompanyID) ||
                                            row.investorCompany ||
                                            "-";

                                        return (
                                            <tr 
                                                key={index} 
                                                style={{ cursor: "pointer" }}
                                                onClick={() => history.push(`/investmentregister/${registerID}/${row.investmentPairKey}`)}
                                            >
                                                <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                    {investorName}
                                                </td>
                                                <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                    {row.investeeCompanyData?.company_name || "-"}
                                                </td>

                                                {/* UPDATED */}
                                                <td style={{ textAlign: "right", paddingRight: "40px" }}>
                                                    {latest?.totalConsideration
                                                        ? formatIndianCurrency(latest.totalConsideration)
                                                        : "-"}
                                                    </td>
                                                <td style={{ textAlign: "right", paddingRight: "40px" }}>{latest?.noOfSharesPurchased || "-"}</td>
                                                <td style={{ textAlign: "right", paddingRight: "40px" }}>
                                                {latest?.noOfSharesPurchased && latest?.totalSharesOutstanding
                                                    ? ((latest.noOfSharesPurchased / latest.totalSharesOutstanding) * 100).toFixed(1) + "%"
                                                    : "-"}
                                                </td>
                                                <td style={{ textAlign: "left", paddingLeft: "20px" }}>{latest?.natureOfRelationship || "-"}</td>

                                                <td onClick={(e) => e.stopPropagation()}>
                                                    <MenuDotsIcon
                                                        onClick={(e) => handleClick(e, row)}
                                                        style={{ cursor: "pointer", marginRight: 20 }}
                                                    />

                                                    <Popover
                                                        id={id}
                                                        open={open}
                                                        anchorEl={anchorEl3}
                                                        onClose={handleClose}
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                        elevation={0}
                                                        PaperProps={{
                                                            style: {
                                                                boxShadow: 'none',
                                                                backgroundColor: 'transparent',
                                                                overflow: 'visible'
                                                            }
                                                        }}
                                                    >
                                                        <div className={investmentRegisterCss.irOptions}>
                                                            <span
                                                                style={{ borderBottom: "1px solid #EAEEED" }}
                                                                onClick={() => {
                                                                    handleEditIr(IrOneData);
                                                                    handleClose();
                                                                }}
                                                            >
                                                                Edit Investment
                                                            </span>

                                                            <span
                                                                onClick={() => {
                                                                    handleDeleteClick(IrOneData);
                                                                }}
                                                            >
                                                                Delete Investment
                                                            </span>
                                                        </div>
                                                    </Popover>
                                                </td>
                                            </tr>
                                        );
                                    })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </motion.div>
            </div>

            <DeletePopup
                isOpen={deletePopup.isOpen}
                title="Are you sure?"
                message="This transaction will be permanently deleted!"
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeletePopup({ isOpen: false, data: null })}
            />

            <SuccessPopup
                isOpen={successPopup.isOpen}
                message={successPopup.message}
                onClose={() => setSuccessPopup({ isOpen: false, message: "" })}
            />

            <ErrorPopup
                isOpen={errorPopup.isOpen}
                message={errorPopup.message}
                onClose={() => setErrorPopup({ isOpen: false, message: "" })}
            />
        </div>
    );
};

export default IRDetails;